const React = require('react');

class Ingress extends React.Component {
    render() {
        return <p className="ingress">{this.props.text}</p>
    }
}

module.exports = Ingress;
